import {Injectable} from '@angular/core';
import {ApiLearningUnitTeacher, ApiLessonInstance, ApiPersonalProfile} from 'src/app/col/model/rest-model';
import {ColNativeServiceApi} from "../col-native-api";
import {iif, map, Observable, of, switchMap, throwError} from "rxjs";
import {IosBridgeBase} from "../../../../mobile/api-services/bridge/ios-bridge-base";
import {LogsService} from "../../../../utils/services/logs.service";
import {HttpMethod, HttpRequest, HttpResponse, Platform} from "../../../../constraints";

@Injectable({
  providedIn: 'root'
})
export class ColIosService implements ColNativeServiceApi{

  constructor(private bridge: IosBridgeBase,
              private logger: LogsService) {}

  private handleResponse<T>(response: Observable<HttpResponse>): Observable<T> {
    return response.pipe(
      switchMap(response => iif(
        () => response.responseCode == 200,
        of(response.body),
        throwError(() => Error(`Error with code ${response.responseCode}`))
      )),
      map( body => JSON.parse(body))
    )
  }

  private getUrlLessonTeacher(path: string, teacherId?: number) {
    return `/teacher` +
      (teacherId ? `/${teacherId}` : '') +
      path
  }

  createVideoClassroom(teacherId: number, lessonId: number): Observable<ApiLessonInstance<ApiPersonalProfile, ApiLearningUnitTeacher>> {
    this.logger.log(`creating video classroom with lessonId=${lessonId}`)
    const request = new HttpRequest(
      Platform.Lessons, HttpMethod.PUT,
      this.getUrlLessonTeacher(`/lessons/${lessonId}/classroom`, teacherId),
      null,
      null
    )
    return this.handleResponse(this.bridge.callForResponse<HttpResponse>('exchange',{request}));
  }


}
